export enum PolicyAction {
  GET_ITEM = 'GetItem',
  QUERY = 'Query',
  SCAN = 'Scan',
  BATCH_GET = 'BatchGetItem',
  BATCH_WRITE = 'BatchWriteItem',
  PUT_ITEM = 'PutItem',
  DELETE_ITEM = 'DeleteItem',
  UPDATE_ITEM = 'UpdateItem'
}

export type PolicyType = {
  Version: string
  Statement: StatementType[]
}

export type StatementType = {
  Effect: string
  Action: string[]
  Resource: string | string[]
  Condition?: {
    [key: string]: {
      [key: string]: string
    }
  }
}
